// npm install --save-dev @types/d3
// npm install d3
import * as d3 from 'd3';

/**
 * @author kmy
 * @date 2025-04-01
 * @remark 
 * @props None
 */
export default class CsvImporter {
    public static async csvParser(file: File): Promise<any[]> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const text = reader.result as string; // 파일 내용

                const csvParser = d3.dsvFormat(",");
                const csvData = csvParser.parse(text); // CSV 데이터를 객체 배열로 변환
                const csvCol = csvData.columns;
    
                // 2차원 배열로 변환 (각 행을 배열로 바꾸기)
                const parsedData = csvData.map(row => Object.values(row));
    
                // 컬럼명과 데이터 결합
                const parseDataCol = [csvCol, ...parsedData];
    
                // 콘솔 출력
                // console.log("csvData:", csvData);   // CSV 데이터 객체 배열
                // console.log("columns:", csvCol);    // CSV 컬럼명
                
                resolve(parseDataCol);
            };
            
            reader.readAsText(file, 'euc-kr');
            // reader.readAsText(file, 'utf-8');
        });
    }
}